export default __webpack_public_path__ + "./ico-modal.7725946a35f91a1e313b7feb5cfed669.png";